// src/Components/Countdown.jsx
import React, { useState, useEffect } from 'react';

const Countdown = ({ targetDate = '2026-04-21T00:00:00Z' }) => {
  const [timeLeft, setTimeLeft] = useState({});
  const [expired, setExpired] = useState(false);

  useEffect(() => {
    const getTimeLeft = () => {
      const now = new Date();
      const endTime = new Date(targetDate); // UTC-based
      const difference = endTime.getTime() - now.getTime();

      if (difference <= 0) {
        setExpired(true);
        return { days: 0, hours: 0, minutes: 0, seconds: 0 };
      }

      return {
        days: Math.floor(difference / (1000 * 60 * 60 * 24)),
        hours: Math.floor((difference / (1000 * 60 * 60)) % 24),
        minutes: Math.floor((difference / (1000 * 60)) % 60),
        seconds: Math.floor((difference / 1000) % 60),
      };
    };

    setTimeLeft(getTimeLeft()); // run immediately
    const timer = setInterval(() => {
      setTimeLeft(getTimeLeft());
    }, 1000);

    return () => clearInterval(timer);
  }, [targetDate]); // ✅ no more warning

  if (expired) {
    return (
      <div className="text-center w-100">
        <h2 className="fw-bold text-danger">The Event Has Started!</h2>
      </div>
    );
  }

  return (
    <div
      id="countdown"
      className="countdown-inner d-flex w-100 justify-content-around flex-wrap"
    >
      <div className="time text-center px-3 py-2">
        <span className="lh-1 h1 fw-bold">{timeLeft.days}</span>
        <p className="text-secondary text-uppercase fw-semibold mb-0">Days</p>
      </div>
      <div className="time text-center px-3 py-2">
        <span className="lh-1 h1 fw-bold">{timeLeft.hours}</span>
        <p className="text-secondary text-uppercase fw-semibold mb-0">Hours</p>
      </div>
      <div className="time text-center px-3 py-2">
        <span className="lh-1 h1 fw-bold">{timeLeft.minutes}</span>
        <p className="text-secondary text-uppercase fw-semibold mb-0">Minutes</p>
      </div>
      <div className="time text-center px-3 py-2">
        <span className="lh-1 h1 fw-bold">{timeLeft.seconds}</span>
        <p className="text-secondary text-uppercase fw-semibold mb-0">Seconds</p>
      </div>
    </div>
  );
};

export default Countdown;
